import { colors } from '@lmc/common/constants'
import _ from 'lodash'
import { createSelector } from 'reselect'
import {
  getDailyTodos,
  getLogCategories,
  getLogCategoryItems,
  getRecurringTodos,
  getResidentsList,
  getUsersList,
  usePropsFormFields
} from './Lists'

export const getActiveDailyTodos = createSelector([getDailyTodos], (todos) => {
  if (!todos) return null
  return todos.map((todo) => {
    const activeTasks = filterActiveTasks(todo)
    return { ...todo, tasks: activeTasks }
  })
})

export const populateRecurringTodos = createSelector(
  [
    getResidentsList,
    getUsersList,
    getLogCategories,
    getLogCategoryItems,
    getRecurringTodos
  ],
  (residents, carers, categories, items, recurringTodos) => {
    if (!residents || !carers || !categories || !items || !recurringTodos)
      return null

    const activeTodos = recurringTodos.map((recurringTodo) => {
      const residentsList = recurringTodo.resident.map((id) =>
        _.find(residents, { id })
      )
      const carersList = recurringTodo.assignee.map((id) =>
        _.find(carers, { id })
      )
      const icon = getIcon(recurringTodo, categories, items)
      const populatedTodo = {
        ...recurringTodo,
        resident: residentsList,
        assignee: carersList,
        icon
      }
      if (checkInactiveRecurringTodo(populatedTodo)) return null
      return populatedTodo
    })
    return _.compact(activeTodos)
  }
)

export const getTodoSummary = createSelector(
  [getLogCategories, getLogCategoryItems, usePropsFormFields],
  (categories, items, todo) => {
    if (!categories || !items || !todo || !Object.keys(todo).length) {
      return {
        text: '',
        icon: { url: '', color: '' }
      }
    }

    const { category, item, title } = todo
    const { url, color } = getIcon(todo, categories, items)
    let text

    if (category) {
      const categoryData = _.find(categories, { id: category }) || category
      const categoryName = (text = formatName(categoryData.name))

      if (item) {
        const itemData = _.find(items, { id: item }) || item
        // bug???
        if (itemData.name) {
          text = `${text} / ${formatName(itemData.name)}`
        }
      }

      if (title) {
        text = `${categoryName} / ${title}`
      }
    }

    return { text, icon: { url, color } }
  }
)

const getIcon = (recurringTodo, categories, items) => {
  const category = _.find(categories, { id: recurringTodo.category })
  const categoryItem = _.find(items, { id: recurringTodo.item })

  if (!category && !categoryItem) return {}

  const url = categoryItem ? categoryItem.icon : category.icon
  const color = category ? category.color : colors.darkgrey

  return { url, color }
}

const formatName = (name) => {
  return (name.split('/')[1] || name).replace(/^\s/, '')
}

const filterActiveTasks = (todo) => {
  const type = todo.tasks[0].taskType
  const activeTasks = []
  if (type === 'resident') {
    todo.tasks.forEach((task) => {
      const isActive =
        task.resident && ['active', 'dummy'].includes(task.resident.status)
      if (isActive) activeTasks.push(task)
    })
  }
  if (type === 'home') {
    const isActive = _.some(todo.tasks[0].assignee, { active: true })
    if (isActive) activeTasks.push(todo.tasks[0])
  }
  return activeTasks
}

const checkInactiveRecurringTodo = (todo) => {
  if (todo.taskType === 'resident') {
    const isInactive = _.every(todo.resident, (resident) => {
      return !resident || !['active', 'dummy'].includes(resident.status)
    })
    if (isInactive) return true
  }
  if (todo.taskType === 'home') {
    const isInactive = _.every(todo.assignee, { active: false })
    if (isInactive) return true
  }
  return false
}
